/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{alphaCutoff as t,opacityCutoff as o}from"../../../../webscene/support/AlphaCutoff.js";function a(a){a.constants.add("alphaCutoff","float",t),a.constants.add("opacityCutoff","float",o)}export{a as alphaCutoff};
